import { Injectable, signal, WritableSignal } from '@angular/core';
import { Toast } from '@interfaces/toast';
import { TOAST_TIMEOUT } from '@core/config';
import { ToastTypesEnum } from '@models/enums';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public $toasts: WritableSignal<Toast[]> = signal([]);

  public showToast(message: string = '', type: ToastTypesEnum = ToastTypesEnum.INFO): void {
    const id = (Date.now() + Math.random()).toString().slice(0, 20);
    const toast: Toast = { id, message, type, cssClass: type.toLowerCase() };
    this.$toasts.update(toasts => [...toasts, toast]);

    setTimeout(() => this.removeToast(id), TOAST_TIMEOUT);
  }

  public removeToast(id: string): void {
    this.$toasts.update(toasts => toasts.filter(toast => toast.id !== id));
  }
}
